import React from 'react';

/**
 * Genre Filters Component
 *
 * Each Genre click activates specific genreFilter state
 */
const genreFilters = (props) => (
		
		<div className="genre-filters">

			<label className="form-label">Filter By Genre</label>
			<ul className="genres">
		  		<li className="genre-choice">
					<button
						className={ props.genreDefaultFilter ? "genre-choice__button active" : "genre-choice__button" }
						onClick={props.genreDefaultSelection}
					>All</button>
		  		</li>
		  		<li className="genre-choice">
					<button
						className={ props.rockFilter ? "genre-choice__button active" : "genre-choice__button" }
						value="KnvZfZ7vAeA"
						onClick={props.genreSelection}
						data-name="rock"
					>Rock</button>
					<button
						className="genre-choice__close"
						value="KnvZfZ7vAeA"
						onClick={props.removeGenreSelection}
						data-name="rock"
					></button>
		  		</li>
		  		<li className="genre-choice">
					<button
						className={ props.popFilter ? "genre-choice__button active" : "genre-choice__button" }
						value="KnvZfZ7vAev"
						onClick={props.genreSelection}
						data-name="pop"
					>Pop</button>
					<button
						className="genre-choice__close"
						value="KnvZfZ7vAev"
						onClick={props.removeGenreSelection}
						data-name="pop"
					></button>
		  		</li>
		  		<li className="genre-choice">
					<button
						className={ props.hiphopFilter ? "genre-choice__button active" : "genre-choice__button" }
						value="KnvZfZ7vAv1"
						onClick={props.genreSelection}
						data-name="hiphop"
					>Hip/Hop</button>
					<button
						className="genre-choice__close"
						value="KnvZfZ7vAv1"
						onClick={props.removeGenreSelection}
						data-name="hiphop"
					></button>
		  		</li>
		  		<li className="genre-choice">
					<button
						className={ props.danceFilter ? "genre-choice__button active" : "genre-choice__button" }
						value="KnvZfZ7vAvF"
						onClick={props.genreSelection}
						data-name="dance"
					>Dance/Electronic</button>
					<button
						className="genre-choice__close"
						value="KnvZfZ7vAvF"
						onClick={props.removeGenreSelection}
						data-name="dance"
					></button>
		  		</li>
		  		<li className="genre-choice">
					<button
						className={ props.randbFilter ? "genre-choice__button active" : "genre-choice__button" }
						value="KnvZfZ7vAee"
						onClick={props.genreSelection}
						data-name="randb"
					>R & B</button>
					<button
						className="genre-choice__close"
						value="KnvZfZ7vAee"
						onClick={props.removeGenreSelection}
						data-name="randb"
					></button>
		  		</li>
		  		<li className="genre-choice">
					<button
						className={ props.countryFilter ? "genre-choice__button active" : "genre-choice__button" }
						value="KnvZfZ7vAv6"
						onClick={props.genreSelection}
						data-name="country"
					>Country</button>
					<button
						className="genre-choice__close"
						value="KnvZfZ7vAv6"
						onClick={props.removeGenreSelection}
						data-name="country"
					></button>
		  		</li>
		  		<li className="genre-choice">
					<button
						className={ props.metalFilter ? "genre-choice__button active" : "genre-choice__button" }
						value="KnvZfZ7vAvt"
						onClick={props.genreSelection}
						data-name="metal"
					>Metal</button>
					<button
						className="genre-choice__close"
						value="KnvZfZ7vAvt"
						onClick={props.removeGenreSelection}
						data-name="metal"
					></button>
		  		</li>
			</ul>
		</div>
);

export default genreFilters;
